export var NotificationState;
(function (NotificationState) {
    NotificationState["INFO"] = "info";
    NotificationState["ERROR"] = "error";
})(NotificationState || (NotificationState = {}));
//# sourceMappingURL=CsNotification.js.map